import { Directive, ViewChild } from '@angular/core';

import { AgGridAngular } from '@ag-grid-community/angular';
import { GridOptions } from '@ag-grid-community/core';
import { DataService } from '@data/data.service';

@Directive()
export class ZGrid {
  public gridOptions: GridOptions;
  public gridApi: any;
  public gridColumnApi: any;

  @ViewChild('agGrid') agGrid: AgGridAngular;

  selectedRow: any = {};

  constructor(public dataService: DataService) {}

  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.dataService.gridState$.next('ready');
  }

  publishSelectedRow($event: any) {
    const node = this.agGrid.api.getSelectedNodes().length > 0 ? this.agGrid.api.getSelectedNodes()[0] : null;
    this.dataService.selectedRow$.next(node?.data);
    this.dataService.selectedIdx$.next(node?.rowIndex);
    this.selectedRow = $event.api.getSelectedRows()[0];
  }

  editSelectedGridRows(column: any) {
    const row = this.agGrid.api.getSelectedNodes();

    if (!row) {
      return;
    }

    this.agGrid.api.startEditingCell({ rowIndex: row[0].rowIndex, colKey: column });
  }

  copySelectedGridRows() {
    const text: string = this.agGrid.api
      .getSelectedRows()
      .map((row) => {
        return Object.keys(row)
          .map((key) => {
            if (row[key] && !row[key].toString().includes('[object Object]')) {
              return row[key];
            }
          })
          .join('\t');
      })
      .join('\n');

    navigator.clipboard.writeText(text);
  }
}
